import Vue from 'vue'
import Vuex from 'vuex'

// ブラウザをリロードしても store が保持される
import createPersistedState from 'vuex-persistedstate'
// ストレージ保存データの暗号化を行う
import SecureLS from 'secure-ls'

import account from '@/store/modules/account'
import auth from '@/store/modules/auth'
import http from '@/store/modules/http'
import user from '@/store/modules/user'
import order from '@/store/modules/order'
import vehicle from '@/store/modules/vehicle'
import tmpTorihiki from '@/store/modules/tmpTorihiki'
import address from '@/store/modules/address'
import screen from '@/store/modules/screen'
import inquiry from '@/store/modules/inquiry'
import history from '@/store/modules/history'
import info from '@/store/modules/info'
import setting from '@/store/modules/setting'
import password from '@/store/modules/password'
import mail from '@/store/modules/mail'
import trial from '@/store/modules/trial'
import group from '@/store/modules/group'
import invoice from '@/store/modules/invoice'
import photo from '@/store/modules/photo'
import mitumori from '@/store/modules/mitumori'
import util from '@/store/modules/util'

Vue.use(Vuex)

const ls = new SecureLS({ isCompression: false })

export default new Vuex.Store({
  modules: {
    account,
    auth,
    http,
    user,
    order,
    vehicle,
    tmpTorihiki,
    address,
    screen,
    inquiry,
    history,
    info,
    setting,
    password,
    mail,
    trial,
    group,
    invoice,
    photo,
    mitumori,
    util,
  },
  plugins: [
    createPersistedState({
      key: 'loginavi',
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
})



// WEBPACK FOOTER //
// ./src/store/index.js